import axios, { AxiosInstance, AxiosError } from 'axios'
import { ApiResponse } from '../types'

// VITE_API_URL leer = same-origin via /api (nginx-proxy in prod, Vite-Proxy
// in dev — beide strippen den /api-Prefix beim Forward).
// Wenn explizit gesetzt (z.B. http://localhost:3001), wird der Backend
// direkt angesprochen — useful für Mobile-Vite oder Tunnel-Tests.
const API_URL = import.meta.env.VITE_API_URL || '/api'

const client: AxiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  // HttpOnly auth_cookie (SameSite=Strict) — Token wird vom Browser
  // automatisch mitgeschickt, kein Bearer-Header-Injection mehr.
  withCredentials: true,
})

// Legacy-Cleanup: alte localStorage-Token aus früheren Sessions räumen.
// Kann nach 1-2 Wochen entfernt werden.
if (typeof localStorage !== 'undefined' && localStorage.getItem('auth_token')) {
  localStorage.removeItem('auth_token')
}

client.interceptors.response.use(
  (response) => response,
  (error: AxiosError<ApiResponse<unknown>>) => {
    if (error.response?.status === 401 && typeof window !== 'undefined') {
      localStorage.removeItem('user')
      const path = window.location.pathname
      // Bei /auth/me selbst NICHT redirecten — die App-Mount-Routine
      // fängt das normal ab (user=null → ProtectedRoute → /login).
      const isAuthCheck = error.config?.url?.includes('/auth/me')
      if (path !== '/login' && !isAuthCheck) {
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

export { client as apiClient }
export default client
